import React from 'react';
import { useTranslation } from 'react-i18next';
import TitleText from '@/components/atoms/TitleText';
import Map from '@/components/atoms/Map';

interface FeedbackLocationMapProps {
  location: {
    address: string;
    lat: number;
    lng: number;
  };
  'data-testid'?: string;
}

export const FeedbackLocationMap: React.FC<FeedbackLocationMapProps> = ({
  location,
  'data-testid': dataTestId = 'store-order-location-map',
}) => {
  const { t } = useTranslation();

  if (!location?.lat || !location?.lng) return null;

  return (
    <div
      className="p-5 border rounded-xl bg-light-surface-primary dark:bg-dark-surface-primary border-light-input-border dark:border-dark-input-border space-y-4"
      data-testid={dataTestId}
    >
      <TitleText
        text={t('logisticsFeedback.locationTitle')}
        size="base"
        className="!font-bold !text-light-primary dark:!text-dark-primary"
        data-testid={`${dataTestId}-title`}
      />

      <div
        className="w-full h-64 rounded-xl overflow-hidden border border-light-input-border dark:border-dark-input-border relative"
        data-testid={`${dataTestId}-map-wrapper`}
      >
        <Map
          location={{
            lat: location.lat,
            lng: location.lng,
            currentAddress: location.address,
          }}
          viewOnly
          height="100%"
          width="100%"
          dataTestId={`${dataTestId}-map`}
        />
      </div>
    </div>
  );
};

